<template>
  <div class="flex items-center switch-container mr-2 h-full">
    <div class="center con-switch">
      <vs-switch
        class="vs-switch-success"
        @click="ChangeStatus"
        v-model="actiobBtn"
      />
    </div>
  </div>
</template>
<script>
export default {
  mounted () {
    this.actiobBtn = this.params.data.status
  },
  data () {
    return {
      actiobBtn: false
    }
  },
  methods: {
    ChangeStatus () {
      this.params.colDef.filterParams.ChangeStatus(
        this.actiobBtn,
        this.params.data.id,
        this.params.rowIndex,
        'Course'
      )
    }
  }
}
</script>
